import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-emoji-picker',
  templateUrl: './app-emoji-picker.component.html',
  styleUrls: ['./app-emoji-picker.component.scss']
})

export class AppEmojiPickerComponent implements OnInit {

  @Output() clickedEvent = new EventEmitter<any>();

  data: any = [];

  header: any = [
    {
      emoji: "😀",
      group: "Smileys & Emotion",
      target: "smileys_and_emotion"
    },
    {
      emoji: "👌",
      group: "People & Body",
      target: "people_and_body"
    },
    {
      emoji: "🐵",
      group: "Animals & Nature",
      target: "animals_and_nature"
    },
    {
      emoji: "🍉",
      group: "Food & Drink",
      target: "food_and_drink"
    },
    {
      emoji: "🌍",
      group: "Travel & Places",
      target: "travel_and_places"
    },
    {
      emoji: "🎄",
      group: "Activities",
      target: "activities"
    },
    {
      emoji: "👔",
      group: "Objects",
      target: "objects"
    },
    {
      emoji: "🚮",
      group: "Symbols",
      target: "symbols"
    },
    {
      emoji: "🏳️‍🌈",
      group: "Flags",
      target: "flags"
    }
  ]

  smileys_and_emotion: any = [];
  people_and_body: any = [];
  animals_and_nature: any = [];
  food_and_drink: any = [];
  travel_and_places: any = [];
  activities: any = [];
  objects: any = [];
  symbols: any = [];
  flags: any = [];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getEmojiData();
  }

  getEmojiData() {

    this.http.get('assets/js/emoji.json').subscribe(result => {

      this.data = result;

      this.smileys_and_emotion = this.data.filter(function (e) {
        return e.group == "Smileys & Emotion";
      });
      this.people_and_body = this.data.filter(function (e) {
        return e.group == "People & Body";
      });
      this.animals_and_nature = this.data.filter(function (e) {
        return e.group == "Animals & Nature";
      });
      this.food_and_drink = this.data.filter(function (e) {
        return e.group == "Food & Drink";
      });
      this.travel_and_places = this.data.filter(function (e) {
        return e.group == "Travel & Places";
      });
      this.activities = this.data.filter(function (e) {
        return e.group == "Activities";
      });
      this.objects = this.data.filter(function (e) {
        return e.group == "Objects";
      });
      this.symbols = this.data.filter(function (e) {
        return e.group == "Symbols";
      });
      this.flags = this.data.filter(function (e) {
        return e.group == "Flags";
      });
      
    });

  }

  clickEmoji(emoji: any) {
    this.clickedEvent.emit(emoji);
  }

  openTab(tabId) {

    var i, tabcontent, tablinks;
  
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  
    const tabLink = document.querySelector(`[data-id="${tabId}"]`);
    tabLink.className += " active";

    document.getElementById(tabId).style.display = "block";
  }

}
